import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=ee41e5c6&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"
import style0 from "./notifications.vue?vue&type=style&index=0&id=ee41e5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee41e5c6",
  null
  
)

export default component.exports